import { render, staticRenderFns } from "./TreeItem.vue?vue&type=template&id=db234c14&scoped=true"
import script from "./TreeItem.vue?vue&type=script&lang=js"
export * from "./TreeItem.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/pages/archive/tree-item.scss?vue&type=style&index=0&id=db234c14&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db234c14",
  null
  
)

export default component.exports